import SaidasView from "../../components/estoque/SaidasView";

export default function SaidasEstoque() {
  return <SaidasView />;
}
